import { useEffect } from 'react'
import { useMapEngine } from '../shared'
import { useLayer } from '@facility-latam/geoportal-components'

export const Layer = ({ mapId, source, layer }) => {
  const [engine] = useMapEngine(mapId)

  useLayer({
    engine,
    source,
    layer
  })

  useEffect(() => {
    if (engine && layer) {
      engine.setLayoutProperty(layer.id, 'visibility', 'visible')
      engine.moveLayer(layer.id, 'frontiers')
    }
    return () => {
      if (engine && layer) {
        engine.setLayoutProperty(layer.id, 'visibility', 'none')
      }
    }
  }, [engine, layer])

  return null
}
